import { render } from "./CreateResourceButton.vue?vue&type=template&id=0fd43b38"
import script from "./CreateResourceButton.vue?vue&type=script&lang=js"
export * from "./CreateResourceButton.vue?vue&type=script&lang=js"

import exportComponent from "D:\\php-projects\\vemto apps\\tasky\\tasky_api_nova2_v9\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"CreateResourceButton.vue"]])

export default __exports__